<template>
    <modal :show="show" :max-width="maxWidth" :closeable="closeable" @close="close" >
        <div class="bg-gray-700 px-4 pt-5 pb-4 sm:p-6 sm:pb-4" :class="$attrs.extraClass">
            <div class="sm:flex sm:items-start">
                <div class="mx-auto shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg style="color: gray" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-info" viewBox="0 0 16 16">
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" fill="gray"></path>
                    </svg>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 class="text-lg text-white">
                        <slot name="title"></slot>
                    </h3>
                    <div class="mt-2 text-white">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="px-6 py-4 bg-gray-700 text-right" :class="$attrs.extraClass">
            <slot name="footer">
            </slot>
        </div>
    </modal>
</template>
<script>
import Modal from './Modal.vue'

export default {
    emits: ['close'],

    components: {
        Modal,
    },

    props: {
        show: {
            default: false
        },
        maxWidth: {
            default: '2xl'
        },
        closeable: {
            default: true
        },
    },

    methods: {
        close() {
            this.$emit('close')
        },
    }
}

</script>
